<template>
  <div class="warn2" :class="{'warn2_green': styleType=='typeGreen'}">
    <div class="warn2_title">
      <div class="popup-type1-title" :class="{ 'popup-type1-title_green': treatType }">
        {{data.typeName}}-{{
          data.metric +
          (data.warnType === 1 ? "超标" : data.warnType === 2 ? "超低" : "")
        }}
      </div>
      <div class="popup-type1-time">
        {{ data.eventTime ? data.eventTime.slice(5, 16) : "" }}
      </div>
    </div>
    <div class="warn2_top">
      <div class="warn2_content">
        <div class="warn2_state">
          闭环控制状态: <span :class="{ done_green: treatType }">{{ handleState_ }}</span>
        </div>
        <div class="warn2_branchFac">
          所属区域: <span>{{ data.branchFactory }}</span>
        </div>
        <div class="warn2_position">
          发生位置: <span :title="data.deviceName">{{ data.deviceName }}</span>
        </div>
      </div>
      <div class="warn2_box" v-show="!treatType">
        <div class="smallBox">
          <div class="warn2_type_name">{{ data.metric }}</div>
          <div class="warn2_type_num">{{ data.value }}</div>
          <div class="warn2_type_unit">{{ data.unit }}</div>
        </div>
      </div>
    </div>
    <div class="warn2_img" v-show="!treatType && imgsrc">
      <img :src="imgsrc" alt="">
    </div>
    <div class="warn2_charts" v-show="!treatType && haveData">
      <div class="warn2_charts_inner" ref="chart">
      </div>
    </div>
    <div class="treatRecords">
      <div class="treatTitle">处理记录：</div>
      <ul class="treatList">
        <li class="treatEveryList" v-for="(item, i) in treatRecords" :key="i">
          <div class="listLeft">
            <div class="listStatus">{{ item.state }}</div>
            <div class="treatMan" v-show="Boolean(item.receiveUserName)">
              {{ item.receiveUserName }}
            </div>
          </div>

          <div class="listTime">{{ item.createTime }}</div>
        </li>
      </ul>
    </div>
    <div class="warn2_project_25" :class="{'warn12_project_50':treatRecords.length==2,'warn2_project_75':treatRecords.length==3,'warn2_project_100':treatRecords.length>=4}">
    </div>
  </div>
</template>
<script>
import getOpt from "./js/chartOpt.js";
import { unwarp } from "@/utils/tools.js";

export default {
  components: {},
  props: ["data", "typeId"],
  data() {
    return {
      customerId: this.$store.state.customerId,
      chart: null,
      unit: 1,
      handleState_: "",
      treatRecords: [],
      treatType: false,
      warnType: "",
      pmData: {
        xData: [],
        y1Data: [],
      },
      haveData: true,
      imgsrc: "",
      styleType: "",
    };
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  mounted() {
    this.treatRecords = this.data.forwards;
    if (this.treatRecords.length) {
      this.treatRecords.forEach((v, i) => {
        if (v.state == 1) {
          v.state = "已创建";
        } else if (v.state == 2) {
          v.state = "已处理";
        } else if (v.state == 3) {
          v.state = "已分配";
        } else if (v.state == 4) {
          v.state = "处理中";
        }
      });
    }
    if (this.data) {
      if (this.data.warnType == 1) {
        this.warnType = "超标";
      } else if (this.data.warnType == 2) {
        this.warnType = "超低";
      } else if (this.data.warnType == 3) {
        this.warnType = "同步率";
      }
    }
    if (this.data) {
      if (this.data.handleState == 0 || this.data.handleState == 1) {
        this.handleState_ = "处理中";
      } else if (this.data.handleState == 2) {
        this.handleState_ = "已处理";
        this.treatType = true;
      } else if (this.data.handleState == 3) {
        this.handleState_ = "已撤销";
        this.treatType = true;
      } else {
        this.handleState_ = "未知状态";
      }
    }
    if (this.data) {
      if (this.data.typeName.indexOf("VDM") != -1) {
        this.data.typeName = "VDM";
      }
    }
    this.getData();
    if (
      this.data &&
      this.data.imagParams &&
      this.data.imagParams[0] &&
      this.data.imagParams[0].url
    ) {
      this.imgsrc = this.data.imagParams[0].url;
    }
  },
  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  beforeUnmount() {},
  activated() {
    this.getData();
  },
  methods: {
    formatDate(date) {
      var date = new Date(date * 1000);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm;
    },
    getData() {
      if (this.data.valueHistory && this.data.valueHistory.length) {
        let dpsObj = this.data.valueHistory[0].dps;
        if (dpsObj) {
          this.haveData = true;
          let arrNewX = [];
          let arrNewY = [];
          for (let i in dpsObj) {
            arrNewY.push(dpsObj[i].toFixed(2)); //值 ['aaa' 190 'man']
            arrNewX.push(this.formatDate(parseInt(i))); //属性  ['name' 'height' 'sex']
          }
          this.pmData.xData = arrNewX;
          this.pmData.y1Data = arrNewY;
          this.$nextTick(() => {
            if (!this.chart) {
              this.chart = echarts.init(this.$refs.chart);
            }
            let optionStr = getOpt(this.pmData);
            unwarp(this.chart).setOption(optionStr);
          });
        }
      } else {
        this.haveData = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.warn2 {
  position: absolute;
  padding: 30px;
  width: 450px;
  height: 782px;
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  box-shadow: 0px -2px 0px 0px #51eeff, 0px 2px 4px 0px rgba(0, 0, 0, 0.74);
  .warn2_title {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid;
    border-image: linear-gradient(-90deg, #4fa7ff, #88f7ff) 1 1;
    justify-content: space-between;
    .popup-type1-title {
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: #ff7373;
      line-height: 30px;
      display: flex;
      align-items: center;
      &::before {
        content: "";
        display: block;
        width: 7px;
        height: 7px;
        background: #ff7373;
        box-shadow: 0px 0px 7px 0px #df3131;
        border: 1px solid #da3636;
        border-radius: 50%;
        display: inline-block;
        margin-right: 16px;
      }
    }
    .popup-type1-time {
      // height: 14px;
      padding-bottom: 5px;
      font-size: 14px;
      color: #ffffff;
      line-height: 14px;
    }
  }
  .warn2_top {
    display: flex;
    .warn2_content {
      height: 85px;
      width: 60%;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .warn2_state {
        height: 18px;
        font-size: 18px;
        font-weight: 400;
        color: #94a2b0;
        line-height: 18px;
        span {
          color: #f4c48f;
          font-weight: 500;
        }
      }
      .warn2_position {
        height: 18px;
        font-size: 18px;
        font-weight: 400;
        color: #94a2b0;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          color: #4fc5ff;
          font-weight: 500;
        }
      }
      .warn2_branchFac {
        height: 18px;
        font-size: 18px;
        font-weight: 400;
        color: #94a2b0;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          color: #4fc5ff;
          font-weight: 500;
        }
      }
    }
    .warn2_box {
      width: 40%;
      margin-top: 20px;
      height: 85px;
      background: rgba(0, 0, 0, 0.42);
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.66);
      .smallBox {
        @include bg-box(100%, 100%, "warn1_bg.png");
        text-align: center;
        padding-top: 10px;
        .warn2_type_name {
          height: 16px;
          font-size: 16px;
          color: #99f5ff;
          line-height: 16px;
          margin-bottom: 5px;
        }
        .warn2_type_num {
          height: 32px;
          font-size: 32px;
          color: #ffffff;
          line-height: 32px;
          margin-bottom: 5px;
          text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.32);
        }
        .warn2_type_unit {
          height: 12px;
          font-size: 12px;
          color: #aaaaaa;
          line-height: 12px;
          text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.3);
        }
      }
    }
  }
  .warn2_img {
    width: 380px;
    height: 166px;
    margin: 0 auto;
    margin-top: 25px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .warn2_charts {
    width: 390px;
    height: 135px;
    margin-top: 10px;
    .warn2_charts_inner {
      width: 390px;
      height: 135px;
    }
  }
  .treatRecords {
    width: 100%;
    margin-top: 20px;
    .treatTitle {
      height: 18px;
      font-size: 18px;
      color: #94a2b0;
      line-height: 18px;
    }
    ul.treatList {
      padding-left: 30px;
      margin-top: 25px;
      position: relative;
      &::before {
        content: "";
        width: 1px;
        background-color: #51eeff;
        height: calc(100% - 40px);
        display: block;
        position: absolute;
        top: 20px;
        left: 15px;
      }
      li {
        height: 40px;
        border-bottom: 1px solid #4069ad;
        display: flex;
        font-size: 16px;
        color: #e8f2fc;
        line-height: 40px;
        align-items: center;
        position: relative;
        justify-content: space-between;
        .listLeft {
          display: flex;
          align-items: center;
          .listStatus {
            margin-right: 20px;
            &:before {
              content: "✔";
              color: #313131;
              line-height: 12px;
              width: 12px;
              height: 12px;
              font-size: 10px;
              top: 13px;
              background: #99f5ff;
              position: absolute;
              left: -20px;
              border-radius: 50%;
            }
          }
          .treatMan {
            width: 100px;
            height: 24px;
            background: #068acb;
            border-radius: 4px;
            line-height: 24px;
            text-align: center;
          }
        }
      }
    }
  }

  .warn2_project_25 {
    margin: 0 auto;
    @include bg-box(416px, 118px, "project_25.png");
  }
  .warn2_project_50 {
    @include bg-box(416px, 118px, "project_50.png");
  }
  .warn2_project_75 {
    @include bg-box(416px, 118px, "project_75.png");
  }
  .warn2_project_100 {
    @include bg-box(416px, 118px, "project_100.png");
  }
}
.warn2.warn2_green {
  background-image: url("./img/warn1_green.png");
  background-size: 100% 100% !important;
}
</style>
<style lang="scss" scoped>
.popup-type1-title_green {
  color: #30d594 !important;
  &::before {
    background: #dffff3 !important;
    box-shadow: 0px 0px 7px 0px rgba(48, 213, 148, 0.81) !important;
    border: 1px solid #30d594 !important;
  }
}
.done_green {
  color: #30d594 !important;
}
</style>
